import Axios from "axios";
import {
    SET_SALARY_PAY_REGISTER_REPORT_LIST, 
    UNSET_SALARY_PAY_REGISTER_REPORT_LIST
} from "@/store/mutation-types";
import {
    getSalaryPayRegisterReport,
} from "@/store/api";

const state = {
    getSalaryPayRegisterReport: [],
};

const getters = {
    getSalaryPayRegisterReport(state) {
        return state.getSalaryPayRegisterReport;
    },
};

const mutations = {
    [SET_SALARY_PAY_REGISTER_REPORT_LIST](state, data) {
        state.getSalaryPayRegisterReport = data;
    },
    [UNSET_SALARY_PAY_REGISTER_REPORT_LIST](state) {
        state.getSalaryPayRegisterReport = [];
    },
};

const actions = {

    getSalaryPayRegisterReport({ commit }, data) {
        return new Promise((resolve, reject) => {
            Axios.get(`${getSalaryPayRegisterReport}`, { params: data })
                .then((response) => {
                    commit(SET_SALARY_PAY_REGISTER_REPORT_LIST, response.data.data );
                    resolve(response);
                })
                .catch((error) => {
                    commit(UNSET_SALARY_PAY_REGISTER_REPORT_LIST);
                    reject(error);
                })
                .finally(() => {
                    commit("UNSET_LOADING");
                });
        });
    },
    

};


export default {
    state,
    getters,
    actions,
    mutations,
};